import { render } from "./MyAccountView.vue?vue&type=template&id=3011f0e1&scoped=true"
import script from "./MyAccountView.vue?vue&type=script&lang=js"
export * from "./MyAccountView.vue?vue&type=script&lang=js"

import "./MyAccountView.vue?vue&type=style&index=0&id=3011f0e1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3011f0e1"]])

export default __exports__